import { render, staticRenderFns } from "./LuExciseIssues.vue?vue&type=template&id=92d27578&"
import script from "./LuExciseIssues.vue?vue&type=script&lang=js&"
export * from "./LuExciseIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports